import { render, staticRenderFns } from "./HomeEmpresa.vue?vue&type=template&id=d6bfb516&scoped=true"
import script from "./HomeEmpresa.vue?vue&type=script&lang=js"
export * from "./HomeEmpresa.vue?vue&type=script&lang=js"
import style0 from "./HomeEmpresa.vue?vue&type=style&index=0&id=d6bfb516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bfb516",
  null
  
)

export default component.exports